import { render } from "./CompaniesList.vue?vue&type=template&id=f0c4342e&ts=true"
import script from "./CompaniesList.vue?vue&type=script&lang=ts"
export * from "./CompaniesList.vue?vue&type=script&lang=ts"

import "./CompaniesList.vue?vue&type=style&index=0&id=f0c4342e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__